/**
 * Created by Mark on 18/04/2017.
 */


import React  from 'react';
import CurriculumServices from '../services/curriculums-services.js';
import CurriculumStore from '../store/curriculum-store.js';
import Layout from '../components/layouts/standard-page.js';
import ListItem from '../components/lists/list-item.js';
import Wizard from '../components/wizard/wizard.js';
import Steps  from '../components/wizard/create-class-steps';
import Profile from '../components/profile/profile.js'
import { Link } from 'react-router'
import { FormattedMessage } from 'react-intl';
import About from '../components/profile/profile-tabs/about-student-panel.js';
import StudentManagement from '../components/profile/profile-tabs/student-class-panel.js';
import Homework from '../components/profile/profile-tabs/homework-class-panel.js';
import Recent from '../components/profile/profile-tabs/recent-student-panel.js';
import Scores from '../components/profile/profile-tabs/student-scores-panel.js';
import StudentService from '../services/student-services.js';
import StudentStore from '../store/student-store.js';
import {Button ,  Breadcrumb} from 'react-bootstrap';
import LanguageServices from '../services/language-services.js';
import LanguageStore from '../store/language-store.js';
import jsPDF from 'jspdf';


export default class StudentProfileComponent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            student: null
        }
    }

    componentDidMount() {
        StudentService.getStudent(this.props.params.studentID);
        StudentService.getStudentLanguages(this.props.params.studentID);
    }

    componentWillMount(){
        StudentStore.on('STUDENT_UPDATE' , () => {
            this.setState({student:StudentStore.student});
        });

        StudentStore.on('STUDENT_LANGUAGE_UPDATE' , () => {
            this.setState({languages:StudentStore.studentlanguages});
        });
    }




    classSidePanel(){

        if(!this.state.student || !this.state.languages) return;


        const classes = this.state.student.classesLinks.map(function(_class){
            return (<li><Link to={_class.link}><i className="zmdi zmdi-link p-r-5"></i>{_class.value}</Link></li>)
        });

        const languages = this.state.languages.map(function(language){
            return <a href="" className="col-xs-2">
                <img className="avatar-img" src={"img/flags/"+language.ietf+".png"} alt=""/>
            </a>
        });

        return<div>
                <div className="pmo-pic">
                    <div className="p-t-20 pmo-stat palette-Branding secondary bg">
                        <h4 className="m-0 c-white">{this.state.student.getName()}</h4>
                        <br />
                        <h4 className="m-0 c-white">{this.state.student.username} - {this.state.student.password}</h4>
                    </div>
                </div>
                <div>
                    <div className="pmo-block pmo-contact hidden-xs p-t-0 p-b-10">
                        <h2><FormattedMessage id={ 'ui-13' } defaultMessage={ 'Login' }/></h2>
                        <ul>
                            {this.state.student.lastLogin}
                        </ul>
                    </div>

                    <div className="pmo-block pmo-contact hidden-xs p-t-0 p-b-10">
                        <h2><FormattedMessage id={ 'ui-830' } defaultMessage={ 'Classes' }/></h2>
                        <ul>
                            {classes}
                        </ul>
                    </div>

                    <div className="pmo-block pmo-contact hidden-xs p-t-0 p-b-20">
                        <h2><FormattedMessage id={ 'ui-839' } defaultMessage={ 'Main Languages' }/></h2>

                        <div className="pmob-body">
                            <div className="row">
                                {languages}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
    }

    getBreadCrumb(){

        if(!this.state.student || !this.state.languages) return;

        return  <Breadcrumb>
                    <Breadcrumb.Item href="#/dashboard">
                        <FormattedMessage id={ 'ui-779' } defaultMessage={ '' }/>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href="#/student/management">
                        <FormattedMessage id={ 'ui-783' } defaultMessage={ '' }/>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>
                        {this.state.student.getName()}
                    </Breadcrumb.Item>
                </Breadcrumb>
    }

    render(){
        return (<Layout>{this.getBreadCrumb()}<Profile name="" data={{studentID:this.props.params.studentID}} sidePanel={this.classSidePanel.bind(this)} stepsNavigation={true} panels={[ About , Recent]} /></Layout>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/student-profile.js